export enum TypeEnum {
    EXPORT, IMPORT
}